import NativePDFViewer from "common/components/NativePDF/NativePDF"
import Spinner from "common/components/Spinner"
import FacturaRecurrenteService from "common/services/FacturaRecurrenteService"
import notification from "common/utils/notification"
import { getFacturaRecurrenteById } from "features/Documentos/redux/documentosExtraActions"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { ProgressSpinner } from "primereact/progressspinner"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useParams } from "react-router-dom"

import { FacturaReadingSimpleDtoProps } from "api/DTOs/FacturaReadingSimpleDto"
import { getFacturasByIdSimple } from "api/Factura.service"
import { TIPO_DOCUMENTO_ENUM } from "api/Types/TipoDocumentoEnum"
import ModalVerDocumento from "common/components/ModalVerDocumento/ModalVerDocumento"
import useToggle from "common/hooks/useToggle"
import {
  clearFacturaRecurrenteState,
  facturasRecurrentesSelector,
} from "features/Documentos/redux/documentosSlice"
import * as ROUTES from "routes/RoutePaths"
import FacturaDetail from "./components/FacturaDetail"
import FacturaHeader from "./components/FacturaHeader"
import FacturasDetailList from "./components/FacturasDetailList"
import ModalArchivosAdjuntos from "./components/ModalArchivosAdjuntos"
import { mapFacturaRecurrenteInfo } from "./constants"

const FacturasRecurrentesDetail = () => {
  const { t } = useTranslation()
  const {
    facturaRecurrente,
    facturaRecurrenteLoading,
    facturasRecurrentesHistoricas,
  } = useSelector(facturasRecurrentesSelector)
  const history = useHistory()
  const params = useParams()
  const dispatch = useDispatch()
  const isLoading = false
  const [pdf, setPdf] = useState()
  const [show, toggle] = useToggle()
  const [modalDocumentoDetail, setModalDocumentoDetail] = useState<{
    show: boolean
    document: FacturaReadingSimpleDtoProps | null
  }>({
    show: false,
    document: null,
  })
  useEffect(() => {
    // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
    dispatch(getFacturaRecurrenteById(params.id))
    return () => {
      dispatch(clearFacturaRecurrenteState())
    }
  }, [dispatch, params])

  const getPDF = useCallback(async () => {
    if (params.id) {
      try {
        const { data: PDFdata } = await FacturaRecurrenteService.getPdfById(
          params.id
        )
        setPdf(PDFdata)
      } catch (error) {
        notification.errorServidor({
          body: `${t("documentos.msg.openError")}`,
        })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id])

  useEffect(() => {
    if (params.id) {
      // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
      getPDF(params.id)
    }
  }, [getPDF, params.id])

  const handleRedirectToList = () => {
    history.push(ROUTES.FACTURAS_RECURRENTES)
  }
  const handleRedirectToEdit = () => {
    history.push(`${ROUTES.EDITAR_FACTURA_RECURRENTE}/${params.id}`, {
      factura: facturaRecurrente,
    })
  }

  const handleDelete = async () => {
    if (params.id) {
      try {
        await FacturaRecurrenteService.deleteFacturaRecurrente(params.id)
        notification.success({
          body: `${t("documentos.msg.deleteExit")}`,
        })
        handleRedirectToList()
      } catch (error) {
        notification.errorServidor({
          body: `${t("documentos.msg.deleteError")}`,
        })
      }
    }
  }

  const handleOpenDocumentoModal = async (id: string) => {
    const facturaById = await getFacturasByIdSimple(id)
    setModalDocumentoDetail({
      show: true,
      document: facturaById,
    })
  }

  return (
    <div className='px-4 pt-4 overflow-auto col h-100 remove-scroll'>
      {isLoading ? (
        <ProgressSpinner />
      ) : (
        <div className='row h-100'>
          <div className='col-lg-5 col-md-12'>
            {facturaRecurrenteLoading ? (
              <Spinner />
            ) : (
              <>
                <FacturaHeader
                  factura={mapFacturaRecurrenteInfo(facturaRecurrente)}
                  onDelete={handleDelete}
                  handleRedirectToList={handleRedirectToList}
                  onEdit={handleRedirectToEdit}
                />
                <FacturaDetail
                  facturaInfo={mapFacturaRecurrenteInfo(facturaRecurrente)}
                  openModalAdjuntos={toggle}
                />

                {facturaRecurrente.fechaInicio && (
                  <FacturasDetailList
                    facturasHistoricas={facturasRecurrentesHistoricas}
                    documentoRecurrenteId={params.id}
                    intervalo={facturaRecurrente.intervalo}
                    startDate={facturaRecurrente.fechaInicio}
                    razonSocial={
                      mapFacturaRecurrenteInfo(facturaRecurrente).razonSocial
                    }
                    handleOpenModalFacturaDetail={handleOpenDocumentoModal}
                  />
                )}
              </>
            )}
          </div>

          <div className='col-lg-7 col-md-12 pdf-factura-container'>
            <NativePDFViewer
              pdf={pdf}
              type='stream'
            />
          </div>
        </div>
      )}
      <ModalVerDocumento
        showModal={modalDocumentoDetail.show}
        onHide={() =>
          setModalDocumentoDetail({
            show: false,
            document: null,
          })
        }
        docType={TIPO_DOCUMENTO_ENUM.FACTURA}
        documentoID={modalDocumentoDetail.document?.id ?? null}
        typeDocumentTable='facturas'
      />
      {show && (
        <ModalArchivosAdjuntos
          show={show}
          setShow={toggle}
          facturaId={facturaRecurrente?.id}
          refresByIdFactura={() =>
            // @ts-expect-error TS(2554): Expected 0 arguments, but got 1.
            dispatch(getFacturaRecurrenteById(params.id))
          }
        />
      )}
    </div>
  )
}

export default FacturasRecurrentesDetail
